import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import OutlineClose from 'react-md-icon/dist/OutlineClose';

import { Toaster, DownloadButton } from '../../';

const DrawerHeader = ({
  title,
  toggle,
  downloadAction,
  useFormattedMessage,
}) => (
  <Fragment>
    <div className="modal-header px-4 d-flex align-items-center">
      <h5 className="modal-title">
        {useFormattedMessage ?
          <FormattedMessage id={title} />
        :
          title}
      </h5>
      <div className="d-flex align-items-right">
        {
          downloadAction ?
            <DownloadButton
              downloadAction={downloadAction}
              classes={['close', 'btn-download']}
            /> : undefined
        }
        <button type="button" className="close" aria-label="Close" onClick={toggle}>
          <span aria-hidden="true" className="d-flex">
            <OutlineClose style={{ fontSize: '1.5rem', lineHeight: 1 }} />
          </span>
        </button>
      </div>
    </div>
    <Toaster classNames={['mb-0', 'banner']} renderLocation="drawer" />
  </Fragment>
);

DrawerHeader.defaultProps = {
  downloadAction: undefined,
  useFormattedMessage: true,
};

DrawerHeader.propTypes = {
  title: PropTypes.string.isRequired,
  toggle: PropTypes.func.isRequired,
  downloadAction: PropTypes.func,
  useFormattedMessage: PropTypes.bool,
};

export default DrawerHeader;



// WEBPACK FOOTER //
// ./src/components/Drawer/Header/Header.jsx